export const Routes = {
  fit: '/fit',
  dashboardEngine: '/dashboard-engine',
  leaderboards: '/leaderboards',
  dashboards: '/dashboards',
  mediaDashboardFranchisee: '/media-dashboard-franchisee',
  mediaDashboardFranchisor: '/media-dashboard-franchisor',
}
